import { useContext, useState } from "react";
import { ConfigContext } from "../Context/ConfigContext";

export const UseRewardsPoints = (amount) => {
    const { rewards_points } = useContext(ConfigContext);

    const points = Number(amount) * (Number(rewards_points) / 100);

    return Math.round(points);
};

export const ImageWithFallback = ({ src, index, alt, fallbackText, OE }) => {
    const [imgError, setImgError] = useState(false);

    const handleError = () => {
        setImgError(true);
    };

    const fallbackStyle = {
        textAlign: "center",
        fontSize: "10px",
        padding: "10px",
        wordBreak: "break-word",
        maxWidth: "90%",
    };

    const containerStyle = {
        position: "relative",
        width: "100%",
        height: "30px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    };

    return (
        <div style={containerStyle}>
            {imgError ? (
                <div style={fallbackStyle}>{fallbackText}</div>
            ) : (
                <img
                    draggable="false"
                    style={{
                        height: "30px",
                        margin: "auto",
                        float: "none",
                        marginTop: OE === false ? "5px" : 0,
                    }}
                    key={`img-part-${index}`}
                    src={src}
                    alt={alt}
                    onError={handleError}
                />
            )}
        </div>
    );
};